import { SET_SUMMARY } from "../actions/types";
import initialState from './initialState';

export default (prevState = initialState.summary, action) => {
    switch (action.type) {
        case SET_SUMMARY:
            return [...prevState, action.payload.value];
        default:
            return prevState;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/summaryReducer.js